import {
  ACCESS_TOKEN,
  REFRESH_TOKEN,
  USER_ID,
  USER_EMAIL,
  USER_EXPIRATION,
  EMPLOYEE_ID,
  MATRIX_ID,
  COMPANY_IDS,
  UC_SCHEDULE_COMPANY_ID,
  USER_NAME,
  MODULE,
  SHOW_WITHOUT_MOVIMENTS,
  UG_HASH,
  IS_MASTER_PASSWORD_AUTHENTICATION,
} from './constants';

const removeUserFromLocalStorage = () => {
  const keysToRemove = [
    ACCESS_TOKEN,
    REFRESH_TOKEN,
    USER_ID,
    USER_EMAIL,
    USER_EXPIRATION,
    EMPLOYEE_ID,
    MATRIX_ID,
    COMPANY_IDS,
    UC_SCHEDULE_COMPANY_ID,
    USER_NAME,
    MODULE,
    SHOW_WITHOUT_MOVIMENTS,
    'ul-news-id-visited',
    UG_HASH,
    IS_MASTER_PASSWORD_AUTHENTICATION,
  ];

  keysToRemove.forEach((key) => {
    localStorage.removeItem(key);
  });
};

export default removeUserFromLocalStorage;
